import { FC, useCallback, useEffect, useRef, useState } from 'react';

type Formatter = (value: number) => string;

interface Props {
  value: number;
  formatterFn: Formatter;
  isVisible: boolean;
  isPrimary: boolean;
}

export const BarChartEntryValue: FC<Props> = ({
  value,
  formatterFn,
  isVisible,
  isPrimary,
}) => {
  const [ref, setRef] = useState<HTMLSpanElement | null>(null);
  const animationRef = useRef<number>(NaN);
  const currValue = useRef(0);

  const animate = useCallback(() => {
    if (!ref) return;
    const newValue = lerp(currValue.current, value, 0.1);
    currValue.current = newValue;
    ref.innerHTML = formatterFn(newValue);
    if (currValue.current.toFixed(2) === value.toFixed(2)) {
      window.cancelAnimationFrame(animationRef.current);
      animationRef.current = NaN;
      return;
    }
    animationRef.current = window.requestAnimationFrame(animate);
  }, [ref, value]);

  useEffect(() => {
    if (isVisible && ref) {
      window.requestAnimationFrame(animate);
    }
  }, [ref, isVisible]);
  useEffect(() => {
    currValue.current = 0;
    if (isVisible && ref) {
      window.requestAnimationFrame(animate);
    }
  }, [isPrimary]);
  return <span ref={setRef} />;
};

function lerp(start: number, end: number, amt: number) {
  return (1 - amt) * start + amt * end;
}
